import moment from "moment";
import { range } from "../Arrays";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

const MIN_CAR_CREATION_YEAR = 1886;

function getBrandsList() {
	return [];
}

function getRangeYears() {
	const year = moment().format(DATE_FORMAT.yearOnly);
	const years = range(MIN_CAR_CREATION_YEAR, Number(year));
	return years.map((element) => ({ year: element }));
}

export { getRangeYears, getBrandsList };
